<core-header [showLinks]="false" [showUsername]="false" [showChat]="false"></core-header>
<main>
    <router-outlet></router-outlet>
</main>
<core-footer></core-footer>